module.exports = __webpack_public_path__ + "img/01_03.1f423ee8.png";